{
  "name": "@asicupv/paella-core",
  "exports": {
    ".": "./dist/paella-core.js",
    "./src/": "./src/",
    "./paella-core.css": "./dist/paella-core.css"
  },
  "version": "2.12.14",
  "description": "Multi stream HTML video player",
  "main": "./dist/paella-core.js",
  "publishConfig": {
    "access": "public"
  },
  "files": [
    "dist/paella-core.css",
    "dist/paella-core.js",
    "dist/paella-core.js.map",
    "dist/paella-core.d.ts"
  ],
  "module": "./dist/paella-core.js",
  "types": "./dist/paella-core.d.ts",
  "type": "module",
  "scripts": {
    "dev": "vite build --watch",
    "build": "vite build --emptyOutDir && npm run bundle:types",
    "bundle:types": "dts-bundle-generator --project tsconfig.bundle-types.json -o dist/paella-core.d.ts dist/index.d.ts --no-check",
    "types": "tsc -p tsconfig.debug.json",
    "i18n:check": "i18n-check -s es-ES -l ./src/i18n",
    "clean:build": "rimraf .turbo dist",
    "clean:deps": "rimraf node_modules"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/polimediaupv/paella-player.git"
  },
  "keywords": [
    "html",
    "player",
    "video",
    "hls"
  ],
  "author": "Fernando Serrano Carpena <ferserc1@gmail.com>",
  "license": "ECL-2.0",
  "bugs": {
    "url": "https://github.com/polimediaupv/paella-player/issues"
  },
  "homepage": "https://github.com/polimediaupv/paella-player#readme",
  "devDependencies": {
    "dts-bundle-generator": "^9.5.1",
    "typescript": "^6.0.3",
    "vite": "^8.0.10",
    "vite-plugin-dts": "^4.5.4"
  },
  "dependencies": {
    "@ferserc1/input-style-unifier": "^0.0.2",
    "webvtt-parser": "^2.2.0"
  }
}
